import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

//constants

//validators
import { dropDownValidator, emailValidator } from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator } from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'

//constants
import { Constants } from '../../constants/Constants';

//components

//base
import { BaseControlGroupComponent } from '../../baseclasses/BaseControlGroup.component';
import { DunningProcedureDropdownComponent } from '../DomainData/DunningProcedureDropdown.component';
import { DunningBlockDropdownComponent } from '../DomainData/DunningBlockDropdown.component';
import { EligibilityIndicatorDropdownComponent } from '../DomainData/EligibilityIndicatorDropdown.component';
import { PaymentTermDropdownComponent } from '../DomainData/PaymentTermDropdown.component';
import { PaymentOptionMultiSelectComponent } from '../DomainData/PaymentOptionMultiSelect.component';
import { SelectionRuleDropdownComponent } from '../DomainData/SelectionRuleDropdown.component';
import { CreditHoldActionDropdownComponent } from '../DomainData/CreditHoldActionDropdown.component';
import { PaymentOption } from '../../entities/index';

@Component({
    selector: 'my-accounting-details',
    templateUrl: './AccountingDetails.component.html',
    providers: [{ provide: BaseControlGroupComponent, useExisting: forwardRef(() => AccountingDetailsComponent) }]
})
export class AccountingDetailsComponent extends BaseControlGroupComponent {

    public form: FormGroup;
    accountingInfo: ent.AccountingInfo = new ent.AccountingInfo();

    @Input() public showAccountingClerk: boolean;
    @Input() public showDunningClerk: boolean;
    @Input() public showDunningProcedure: boolean;
    @Input() public showDunningBlock: boolean;
    @Input() public showEligibilityIndicator: boolean;
    @Input() public showPaymentTerm: boolean;
    @Input() public showPaymentOptions: boolean;
    @Input() public showSelectionRule: boolean;
    @Input() public showCreditHoldAction: boolean;

    @Input() public requireAccountingClerk: boolean;
    @Input() public requireDunningClerk: boolean;
    @Input() public requireDunningProcedure: boolean;
    @Input() public requireDunningBlock: boolean;
    @Input() public requireEligibilityIndicator: boolean;
    @Input() public requirePaymentTerm: boolean;
    @Input() public requireSelectionRule: boolean;
    @Input() public requireCreditHoldAction: boolean;


    @ViewChild(DunningProcedureDropdownComponent) public dunningProcedureDropdownComponent: DunningProcedureDropdownComponent;
    @ViewChild(DunningBlockDropdownComponent) public dunningBlockDropdownComponent: DunningBlockDropdownComponent;
    @ViewChild(EligibilityIndicatorDropdownComponent) public eligibilityIndicatorDropdownComponent: EligibilityIndicatorDropdownComponent;
    @ViewChild(PaymentTermDropdownComponent) public paymentTermDropdownComponent: PaymentTermDropdownComponent;
    @ViewChild(PaymentOptionMultiSelectComponent) public paymentOptionMultiSelectComponent: PaymentOptionMultiSelectComponent;
    @ViewChild(SelectionRuleDropdownComponent) public selectionRuleDropdownComponent: SelectionRuleDropdownComponent;
    @ViewChild(CreditHoldActionDropdownComponent) public creditHoldActionDropdownComponent: CreditHoldActionDropdownComponent;

    setDates() { }

    setRequestInfo(request: ent.Request) {
        this.accountingInfo = request.AccountingInfo;

        this.paymentOptionMultiSelectComponent.selectedIDs = [];

        if (request.RequestPaymentOptions) {
            for (var requestPaymentOption of request.RequestPaymentOptions) {
                this.paymentOptionMultiSelectComponent.selectedIDs.push(requestPaymentOption.PaymentOptionID);
            }
        }
    }

    constructor(fb: FormBuilder) {
        super();
        let group = {
            'accountingClerk': '',
            'dunningClerk': '',
            'dunningProcedure': '',
            'dunningBlock': '',
            'eligibilityIndicator': '',
            'paymentTerm': '',
            'paymentOptions': '',
            'selectionRule': '',
            'creditHoldAction': ''

        };

        this.form = fb.group(group);

    }


    ngOnInit(): void {
        if (this.requireDunningProcedure) {
            this.form.controls['dunningProcedure'].setValidators(Validators.required);
        }

    }

    accountingClerkChange(event: any) {
        this.accountingInfo.AccountingClerkID = event;
    }

    dunningClerkChange(event: any) {
        this.accountingInfo.DunningClerkID = event;
    }

    dunningProcedureChange(event: any) {
        this.accountingInfo.DunningProcedureID = event;
    }

    dunningBlockChange(event: any) {
        this.accountingInfo.DunningBlockID = event;
    }

    eligibilityIndicatorChange(event: any) {
        this.accountingInfo.EligibilityIndicatorID = event;
    }

    paymentTermChange(event: any) {
        this.accountingInfo.PaymentTermID = event;
    }

    selectionRuleChange(event: any) {
        this.accountingInfo.SelectionRuleID = event;
    }

    creditHoldActionChange(event: any) {
        this.accountingInfo.CreditHoldActionID = event;
    }

}